module.exports = __webpack_public_path__ + "static/media/featured-3-bed-tc.4a792182.png";